
      import Telephone from './telephone.vue'
      import type { App, Plugin } from 'vue'

      export const TelephonePlugin: Plugin = {
        install(app: App) {
          app.component('Telephone', Telephone)
        },
      }
      export { Telephone }
      